var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "build-info" }, [
      _c("p", [_vm._v("info backend")]),
      _c("pre", [_vm._v(_vm._s(_vm.backend_data))])
    ]),
    _c("div", { staticClass: "build-info" }, [
      _c("p", [_vm._v("info frontend")]),
      _c("pre", [_vm._v(_vm._s(_vm.frontend_data))])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b66dab68", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b66dab68","hasScoped":true,"optionsId":"1","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=1!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/apps/info/spv.vue
// module id = mWal
// module chunks = 0